import Swiper from 'swiper';
import { xl, xl2 } from '../common';

export function initAllArticleSearchBlocks() {
  const blocks = document.querySelectorAll('.js-articles-search');
  blocks.forEach((block) => initArticlesSearch(block));
}

export function initArticlesSearch(parent) {
  if (!parent) return;

  const swiperEl = parent.querySelector('.articles-search__selects-swiper');
  if (swiperEl) {
    new Swiper(swiperEl, {
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 16,
      breakpoints: {
        [xl]: {
          spaceBetween: 20,
        },
        [xl2]: {
          spaceBetween: 24,
        },
      },
    });
  }
}
